import { z } from "zod";
import * as themeScheme from "@ecp-redux/dto/themeSettings/themeSettings.schemes";

export const BoxVideoMessagesScheme = z.object({
  box_video_content_videoTitle: themeScheme.MessageScheme.default(""),
  box_video_content_seo_description: themeScheme.MessageScheme.default(""),
});
